import { Dispatch, FC, PropsWithChildren, SetStateAction, createContext, useContext, useMemo, useState } from "react"

interface PendingState {
    setPending: Dispatch<SetStateAction<boolean>>
}
const PendingContext = createContext<PendingState>({ setPending: () => {} })

export const PendingProvider = ({ children, Pending }: PropsWithChildren<{ Pending: FC }>) => {
    const [pending, setPending] = useState(false)
    const value = useMemo(() => ({ setPending }), [setPending])
    return (
        <PendingContext.Provider value={value}>
            {pending && <Pending />}
            {children}
        </PendingContext.Provider>
    )
}

export const usePending = () => useContext(PendingContext)
